import { WmsTransportHeaderDto, WmsTransportDetailDto } from 'src/dtos/wmsTransport/wmsTransportDto';

export interface KSK1090_R01Dto extends WmsTransportHeaderDto {
    // === Detail 필드 (flat) ===
    itemNo: string;
    itemCd: string;
    itemStatus: string;
    unit: string;
    qty: number;
    cost: number;
    amt: number;
    
    // === 조인으로 가져온 추가 정보 ===
    compNm: string;           // sys_company 조인
    logicCenterNm: string;    // sys_code 조인
    warehouseNm: string;      // mst_warehouse 조인
    inoutTypeNm: string;      // sys_code 조인
    inoutClassNm: string;     // sys_code 조인
    customNm: string;         // mst_custom 조인
    itemNm: string;           // mst_item 조인
    itemSpec: string;         // mst_item 조인
    empNm: string;           // sys_employee 조인
    
    // === 검색 조건 (옵셔널) ===
    itemGroup?: string;
    brandCd?: string;
    brandNm?: string;
}

export const defaultKSK1090_R01Data: KSK1090_R01Dto = {
    // BaseDto (from WmsTransportHeaderDto)
    valueIndex: 0,
    orderIndex: 0,
    orderIndexSeq: 0,
    
    // WmsTransportHeaderDto
    transportNo: '',
    compCd: '',
    logicCenter: '',
    warehouseCd: '',
    transportDt: undefined,
    inoutType: '',
    inoutClass: '',
    customCd: '',
    otherLogicCenter: '',
    inoutMethod: '',
    empNo: '',
    transAmt: 0,
    vatAmt: 0,
    totalAmt: 0,
    telNo: '',
    faxNo: '',
    email: '',
    post: '',
    address: '',
    otherAddress: '',
    trackingNo: '',
    approveFlg: '',
    remark: '',
    inserted: false,
    isModified: false,
    
    // Detail fields
    itemNo: '',
    itemCd: '',
    itemStatus: '',
    unit: '',
    qty: 0,
    cost: 0,
    amt: 0,
    
    // 조인 정보
    compNm: '',
    logicCenterNm: '',
    warehouseNm: '',
    inoutTypeNm: '',
    inoutClassNm: '',
    customNm: '',
    itemNm: '',
    itemSpec: '',
    empNm: '',
};

export type GridRowData = KSK1090_R01Dto;